/**
 * アニメーションを扱うクラスです。
 */
class KoyoriAnimation {
	
	/** アニメーション名を格納するアトリビュート名 */
	static ATTR_ANIMATION_NAME = 'data-animation-name';
	
	static contractOutDown(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'contract-out-down', time)
	}
	
	static contractOutLeft(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'contract-out-left', time)
	}
	
	static contractOutRight(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'contract-out-right', time)
	}
	
	static contractOutUp(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'contract-out-up', time)
	}
	
	static expandInDown(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'expand-in-down', time)
	}
	
	static expandInLeft(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'expand-in-left', time)
	}
	
	static expandInRight(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'expand-in-right', time)
	}
	
	static expandInUp(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'expand-in-up', time)
	}
	
	static fadeInDown(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'fade-in-down', time)
	}
	
	static fadeInLeft(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'fade-in-left', time)
	}
	
	static fadeInRight(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'fade-in-right', time)
	}
	
	static fadeInUp(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'fade-in-up', time)
	}
	
	static fadeIn(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'fade-in', time)
	}
	
	static fadeOutDown(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'fade-out-down', time)
	}
	
	static fadeOutLeft(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'fade-out-left', time)
	}
	
	static fadeOutRight(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'fade-out-right', time)
	}
	
	static fadeOutUp(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'fade-out-up', time)
	}
	
	static fadeOut(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'fade-out', time)
	}
	
	static rotateIn(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'rotate-in', time)
	}
	
	static rotateInfinite(element: HTMLElement, time?: number) {
		KoyoriAnimation.animate(element, 'rotate-infinite', time)
	}
	
	static rotateOut(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'rotate-out', time)
	}
	
	static rotate(element: HTMLElement, time?: number) {
		KoyoriAnimation.animate(element, 'rotate', time)
	}
	
	static scaleDownIn(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'scale-down-in', time)
	}
	
	static scaleDownOut(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'scale-down-out', time)
	}
	
	static scaleUpIn(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'scale-up-in', time)
	}
	
	static scaleUpOut(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'scale-up-out', time)
	}
	
	static slideInDown(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'slide-in-down', time)
	}
	
	static slideInLeft(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'slide-in-left', time)
	}
	
	static slideInRight(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'slide-in-right', time)
	}
	
	static slideInUp(element: HTMLElement, time?: number) {
		KoyoriAnimation.show(element, 'slide-in-up', time)
	}
	
	static slideOutDown(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'slide-out-down', time)
	}
	
	static slideOutLeft(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'slide-out-left', time)
	}
	
	static slideOutRight(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'slide-out-right', time)
	}
	
	static slideOutUp(element: HTMLElement, time?: number) {
		KoyoriAnimation.hide(element, 'slide-out-up', time)
	}
	
	/**
	 * アニメーションを行います。
	 * 
	 * @param element 対象エレメント
	 * @param name アニメーション名（例: fade-out）
	 * @param time アニメーションの秒数
	 */
	static animate(element: HTMLElement, name: string, time?: number) {
		if (time != null) {
			element.style.animationDuration = time + 's';
		} else {
			element.style.animationDuration = '';
		}
		element.classList.remove('koy-' + element.getAttribute(KoyoriAnimation.ATTR_ANIMATION_NAME));
		setTimeout(() => {
			element.setAttribute(KoyoriAnimation.ATTR_ANIMATION_NAME, name);
			element.classList.add('koy-' + name);
		}, 0);
	}
	
	/**
	 * 表示アニメーションを行います。
	 * 
	 * @param element 対象エレメント
	 * @param name アニメーション名（例: fade-in）
	 * @param time アニメーションの秒数
	 */
	static show(element: HTMLElement, name: string, time?: number) {
		if (element.classList.contains('koy-' + name)) {
			element.classList.remove('koy-' + name);
		}
		if (time != null) {
			element.style.animationDuration = time + 's';
		} else {
			element.style.animationDuration = '';
		}
		element.classList.remove('koy-' + element.getAttribute(KoyoriAnimation.ATTR_ANIMATION_NAME));
		setTimeout(() => {
			element.setAttribute(KoyoriAnimation.ATTR_ANIMATION_NAME, name);
			element.classList.add('koy-' + name);
			element.style.display = '';
		}, 0);
	}
	
	/**
	 * 非表示アニメーションを行います。
	 * 
	 * @param element 対象エレメント
	 * @param name アニメーション名（例: fade-out）
	 * @param time アニメーションの秒数
	 */
	static hide(element: HTMLElement, name: string, time?: number) {
		if (element.classList.contains('koy-' + name)) {
			element.classList.remove('koy-' + name);
		}
		if (time != null) {
			element.style.animationDuration = time + 's';
		} else {
			element.style.animationDuration = '';
		}
		element.classList.remove('koy-' + element.getAttribute(KoyoriAnimation.ATTR_ANIMATION_NAME));
		setTimeout(() => {
			element.setAttribute(KoyoriAnimation.ATTR_ANIMATION_NAME, name);
			element.classList.add('koy-' + name);
		}, 0);
		setTimeout(() => {
			element.style.display = 'none';
		}, time != null ? time : 300);
	}

}